exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".an_404{background: url(" + require("../../assets/imgs/404/404bg.jpg") + ") no-repeat center 90px  #ECF1F5;height: 100%;}\n.an_404m{width:520px;height:140px;margin: 0 auto; padding-top: 550px; text-align: center;}\n.an_404m .h2{font-size: 25px;}\n.an_404m .en{color: #C5C5C5; padding: 10px 0;}\n.an_404m .button .ant-btn{height: 38px; padding: 0 30px; border-radius: 50px; margin: 10px;}\n.an_404m .button .ant-btn .anticon{margin: 0 7px;}\n.an_404m .button .ant-btn:nth-child(1){border: 1px solid #ff9600;color: #ff9600;}\n.an_404m .button .ant-btn:nth-child(2){ border: 1px solid #6face2; color:#6face2;}  ", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/no-content/no-content.component.css
// module id = 1038
// module chunks = 75